import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const KEY = 'pw_consent'; // 'accepted' | 'rejected'

export function getConsent() {
  try { return localStorage.getItem(KEY); } catch (e) { return null; }
}

// Consent manager. Optional analytics (GA) must not initialise until the user accepts.
export default function ConsentBanner() {
  const [choice, setChoice] = useState(getConsent());

  useEffect(() => {
    // If already accepted on a previous visit, initialise analytics now.
    if (getConsent() === 'accepted' && typeof window.__pwInitAnalytics === 'function') {
      window.__pwInitAnalytics();
    }
  }, []);

  const decide = (value) => {
    try { localStorage.setItem(KEY, value); } catch (e) { /* ignore */ }
    setChoice(value);
    if (value === 'accepted' && typeof window.__pwInitAnalytics === 'function') {
      window.__pwInitAnalytics();
    }
  };

  if (choice) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[190] p-4" data-testid="consent-banner">
      <div className="max-w-4xl mx-auto rounded-2xl p-5 shadow-2xl flex flex-col sm:flex-row sm:items-center gap-4"
        style={{ backgroundColor: '#0A1F44', border: '1px solid #1D3D72' }}>
        <Cookie className="w-6 h-6 shrink-0 text-[#C0975C] hidden sm:block" />
        <p className="text-sm text-[#c6d0e0] flex-1">
          We use essential cookies to run the site. With your consent we also use analytics cookies to improve it.
          See our <Link to="/privacy" className="text-[#C0975C] underline">Privacy Notice</Link>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button onClick={() => decide('rejected')} data-testid="consent-reject"
            className="px-4 py-2 rounded-lg text-sm font-semibold bg-white/5 text-white border border-[#1D3D72] hover:bg-white/10 transition-colors">
            Essential only
          </button>
          <button onClick={() => decide('accepted')} data-testid="consent-accept"
            className="px-4 py-2 rounded-lg text-sm font-bold bg-[#C0975C] text-[#0A1F44] hover:opacity-90 transition-opacity">
            Accept analytics
          </button>
        </div>
      </div>
    </div>
  );
}
